import { waitForHello } from './port.js';
// prettier-ignore
export function openHostBridge(iframe, opts) {
    const frame = iframe.contentWindow;
    return waitForHello({ ...opts, localWindow: window, origin: opts.gameOrigin, source: frame }, (_event, connect) => {
        const channel = new MessageChannel();
        frame.postMessage(JSON.stringify(opts.hello), opts.gameOrigin, [channel.port2]);
        connect(channel.port1);
    });
}
//# sourceMappingURL=host.js.map